module.exports = __webpack_public_path__ + "assets/img/guarantee3.56267db3.png";